import {
  DatabaseNameParams,
  PackageNameParams,
  ResourceTypeParams,
  SchemaNameParams,
  SourceNameParams,
} from './linkTypes';

export const selectDepth = (
  baseSelector: string,
  ancestors: number | '+' = 0,
  descendents: number | '+' = 0,
) => {
  let prefix = '';
  let suffix = '';
  if (ancestors === '+') {
    prefix = '+';
  } else if (ancestors === 0) {
    prefix = '';
  } else {
    prefix = `${ancestors}+`;
  }
  if (descendents === '+') {
    suffix = '+';
  } else if (descendents === 0) {
    suffix = '';
  } else {
    suffix = `+${descendents}`;
  }
  return `${prefix}${baseSelector}${suffix}`;
};

interface ResourceTypeFilterParams extends ResourceTypeParams {
  depth?: number;
}

export const resourceTypeSelector = ({
  resourceType,
  depth,
}: ResourceTypeFilterParams) => {
  return selectDepth(`resource_type:${resourceType}`, depth, depth);
};

interface ResourceFilterParams {
  fqn: string[];
  depth?: number;
}

export const targetResourceSelector = ({ fqn, depth }: ResourceFilterParams) => {
  // NOTE: `fqn:` is implicit and we don't need to include it in the selector
  return selectDepth(fqn.join('.'), depth, depth);
};

interface SourceNameFilterParams extends SourceNameParams {
  depth?: number;
}

export const sourceNameSelector = ({ sourceName, depth }: SourceNameFilterParams) => {
  return selectDepth(`source:${sourceName}`, 0, depth);
};

interface PackageNameFilterParams extends PackageNameParams {
  depth?: number;
}

export const packageNameSelector = ({
  packageName,
  depth,
}: PackageNameFilterParams) => {
  return selectDepth(`package:${packageName}`, depth, depth);
};

interface DatabaseNameFilterParams extends DatabaseNameParams {
  depth?: number;
}

export const databaseNameSelector = ({
  databaseName,
  depth,
}: DatabaseNameFilterParams) => {
  return selectDepth(`config.database:${databaseName}`, depth, depth);
};

interface SchemaNameFilterParams extends SchemaNameParams {
  depth?: number;
}

export const schemaNameSelector = ({ schemaName, depth }: SchemaNameFilterParams) => {
  return selectDepth(`config.schema:${schemaName}`, depth, depth);
};
